import React, { useMemo } from 'react'
import { defineMessages, FormattedMessage, MessageDescriptor } from 'react-intl'

import { ClientFiltersCheckboxSection } from './ClientFiltersCheckboxSection'

export enum EpisodeProgress {
  LONGER = 'LONGER',
}

export type ClientFiltersEpisodeProgressSectionProps = {
  values: EpisodeProgress[]
  onChange: (values: EpisodeProgress[]) => void
}

export const ClientFiltersEpisodeProgressSection: React.FC<ClientFiltersEpisodeProgressSectionProps> = ({
  values,
  onChange,
}) => {
  const filterNames: Record<EpisodeProgress, MessageDescriptor> = useMemo(
    () =>
      defineMessages({
        [EpisodeProgress.LONGER]: {
          defaultMessage: 'Longer episode',
          description: 'Label for filtering conversations by longer episode progress',
        },
      }),
    [],
  )

  return (
    <ClientFiltersCheckboxSection
      title={<FormattedMessage defaultMessage='Episode progress' description='Episode progress filter section' />}
      items={Object.values(EpisodeProgress).map((value) => ({
        id: value,
        text: <FormattedMessage {...filterNames[value]} />,
      }))}
      values={values}
      onChange={onChange}
      name='episodeProgress'
    />
  )
}
